<template>
    <div v-if="isLoading" class="text-center m-4">
        <b-spinner style="width: 2.5rem; height: 2.5rem;" variant="primary" label="Text Centered"></b-spinner> 
    </div>

    <div v-else class="mas-screening-result mt-4">
        <div v-for="result in masScreeningResult" :key="result.uniqueId" class="result border rounded mb-2">
            <a v-b-toggle class="d-flex justify-content-between align-items-center p-1" :href="`#${result.uniqueId}`" @click.prevent="showMore(result)">
                <div class="brief-result d-flex align-items-center">
                    <b-avatar v-if="result.dataType === 'individual'" class="mr-2" size="37"></b-avatar>
                    
                    <div v-else> 
                        <b-avatar class="mr-2" size="37">
                            <vector 
                                data-type="icons" 
                                data-width="25px" 
                                data-height="25px" 
                                data-name="company_without_user"
                                style="margin-top:3px"

                             />
                        </b-avatar>
                    </div>
                    <div>
                         <div class="name h4">
                            {{ result.firstName ?  result.firstName : result.name }} 
                            {{ result.secondName ? result.secondName : '' }}
                         </div>
                         <div> {{result.category}} </div>
                    </div>
                </div>
                
                <a class="toggle-bottom">
                    <feather-icon
                        class="cursor-pointer"
                        icon="ChevronUpIcon"
                        width="18"
                        height="18"
                    />
                </a> 
            </a>
            <b-collapse :id="result.uniqueId">
                <div class="pb-2 mx-1">
                    <b-container v-for="key in Object.keys(result)" :key="key" class="result-details">
                        <div v-if="isShowResult(key) && isKeyHasValue(result[key])">
                            <b-row 
                                :class="key === 'referenceNumber' ? 'text-left' : 'text-left border-bottom'" 
                                style="padding: 8px;">
                                <b-col> 
                                    {{ getLabel(key) }}
                                </b-col>

                                <b-col cols="8">
                                    <div v-if="typeof(result[key]) === 'object'">
                                        <ul style="padding:0; margin:0; margin-left:9px; list-style-type: circle;">
                                            <li v-for="(data) in  Object.keys(result[key])" :key="data">
                                                <div v-if="typeof(result[key][data]) === 'object'">
                                                    <li v-for="nestedValue in Object.keys(result[key][data])" :key="nestedValue">
                                                        <span class="document-contents" v-html="searchKeyIncludeString(result[key][data][nestedValue])"> </span>
                                                    </li>
                                                </div>
                                                <div v-else>
                                                    <span class="document-contents" v-html="searchKeyIncludeString(result[key][data])"> </span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div v-else>
                                        <span class="document-contents" v-html="searchKeyIncludeString(result[key])"> </span>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                    </b-container>
                </div>
            </b-collapse>
        </div>
    </div>
</template>

<script>
import {
    BCollapse,
    VBToggle,
    BAvatar,
    BContainer,
    BSpinner,
    BRow,
    BCol,
} from "bootstrap-vue";

export default {
    components: {
        BCollapse,
        BAvatar,
        BContainer,
        BSpinner,
        BRow,
        BCol,
    },

    directives: {
        'b-toggle':  VBToggle
    },

    props: {
        isLoading : {
            type: Boolean,
            required: true,
        },

        masScreeningResult : {
            type: Array,
            required: true,
        },

        search : {
            type: String,
            default: '',
        }
    },

    data() {
        return {
            doNotShow: [
                "category",
                'uniqueId', 
                "isShowMore", 
                "id", 
                "categoryId", 
                "systemCheck", 
                "dataId",
                "batchNo",
                // "referenceNumber"
                "dataType",
            ],
        };
    },

    methods: {
        showMore (data) {
            // eslint-disable-next-line no-param-reassign
            data.isShowMore = !data.isShowMore;
        },

        getLabel(key) {
            return key.charAt(0).toUpperCase() + key.slice(1).split(/(?=[A-Z])/).join(' ');
        },

        isShowResult(key) {
            if(this.doNotShow.includes(key))
                return false;
            return true;
        },

        // eslint-disable-next-line consistent-return
        isKeyHasValue(data) {
            if(typeof(data) === 'string') {
                return true;
            }

            if(data && typeof(data) === 'object') {
                const tempStore = [];
                Object.keys(data).forEach(key => {
                    if(data[key])
                        tempStore.push(data[key]);
                });
                if(tempStore.length)
                    return true;
            }
        },

        boldString(str, query) {
            query.split(' ').forEach(qu => {
                const escapedQu = qu.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                // eslint-disable-next-line no-param-reassign
                str = str.replaceAll(new RegExp(`(^|\\s)(${escapedQu})(\\s|)`,'ig'), '$1<b>$2</b>$3');
            });

            return str;
        },

        searchKeyIncludeString(data){
            if(typeof(data) === 'string'){
                return this.boldString(data, this.search);
            }
            return data;
        }
    },
};
</script>

<style scoped>
     .result:hover {
        box-shadow: 0px 0px 8px #dfdada;
    }

    .collapsed .toggle-bottom {
        transform: rotate(-180deg);
        transition: .2s ease-in-out;
    }

    .not-collapsed .toggle-bottom {
        transition: .2s ease-in-out;
    }

    .toggle-bottom {
        border-radius: 50%;
        padding: 10px 10px;
    }

    .toggle-bottom:hover {
        background: #dee6f275;
        border-radius: 50%;
        padding: 10px 10px;
    }
</style>
